import { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "src/redux/store";
import { routeConfig, menuConfig } from "./routeConfig";
import Navigator from "./components/navigator";
import ChatPanel from "./components/chatPanel";

const App = () => {
    const location = useLocation();

    useEffect(() => {
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search + location.hash,
            page_search: location.search,
            page_hash: location.hash
        });
    }, [location]);

    return (
        <Suspense fallback={<h2>Loading...</h2>}>
            <Routes>
                <Route path="/" element={<AppLayout />}>
                    {routeConfig.map((rc) =>
                        <Route
                            key={rc.path}
                            path={rc.path}
                            element={<rc.component />}
                        />
                    )}
                    <Route
                        path={"*"}
                        element={<div style={{ padding: "1rem" }}>
                            <p>Ops! Something is wrong!</p>
                        </div>}
                    />
                </Route>
            </Routes>
        </Suspense>
    );
};

const AppLayout = () => {
    const { pathname } = useLocation();
    const { keycloak } = useSelector((state) => state.keycloakReducer);
    useNavigate();  // Avoid from "maximum update depth exceeded"

    if (pathname != "/ops") {
        const route = routeConfig.find((rc) => rc.path === pathname);
        if (!route) {
            return <Navigate to={"/ops"} replace={true} />;
        } else if (route.auth && !keycloak.authenticated) {
            keycloak.login({ locale: localStorage.getItem("locale") });
            return;
        }
    }

    return (
        <div className="main" style={{
            background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
            position: "absolute",
            minHeight: "100%",
            width: "fit-content"
        }}>
            <Navigator menuConfig={menuConfig} />
            <ChatPanel />
            <Outlet />
        </div>
    );
};

export default App;
